export const DOCS_URL = 'https://docs.cycle.app/';
export const DOCS_WEBHOOKS_URL = 'https://docs.cycle.app/the-graphql-api/webhooks/';
